<template>
    <div class="datetime-wrapper">
        <p>{{ currentDateTime }}</p>
    </div>
</template>

<script setup>
import dayjs from 'dayjs'
import { computed } from 'vue';
import { useNow } from '@vueuse/core'

const now = useNow();

const currentDateTime = computed(() => {
    return dayjs(now.value).format('DD/MM/YYYY HH:mm')
});
</script>
